/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Sentry from "@sentry/nextjs"

// Custom error reporting utility
export const reportError = (error: Error, context?: Record<string, unknown>) => {
  Sentry.withScope((scope) => {
    if (context) {
      Object.keys(context).forEach((key) => {
        scope.setContext(key, context[key] as any)
      })
    }
    Sentry.captureException(error)
  })
}

// Custom message reporting
export const reportMessage = (message: string, level: 'info' | 'warning' | 'error' = 'info') => {
  Sentry.captureMessage(message, level)
}

// Performance monitoring utilities
export const startTransaction = (name: string, op: string) => {
  return Sentry.startSpan({ name, op }, (span) => {
    return span
  })
}

// Set user context
export const setUserContext = (user: {
  id: string
  email?: string
  username?: string
}) => {
  Sentry.setUser(user)
}

// Set custom tags
export const setTag = (key: string, value: string) => {
  Sentry.setTag(key, value)
}

// Set custom context
export const setContext = (key: string, context: Record<string, unknown>) => {
  Sentry.setContext(key, context)
}

// Breadcrumb utilities
export const addBreadcrumb = (breadcrumb: {
  message: string
  category?: string
  level?: 'debug' | 'info' | 'warning' | 'error' | 'fatal'
  data?: Record<string, unknown>
}) => {
  Sentry.addBreadcrumb(breadcrumb)
}
